var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbsconding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8:cancel-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 1.3125C3.864 1.3125 1.3125 3.864 1.3125 7C1.3125 10.136 3.864 12.6875 7 12.6875C10.136 12.6875 12.6875 10.136 12.6875 7C12.6875 3.864 10.136 1.3125 7 1.3125ZM7 2.1875C9.66306 2.1875 11.8125 4.33694 11.8125 7C11.8125 8.19263 11.3794 9.27763 10.6641 10.1172L3.95062 3.26812C4.8111 2.56534 5.88901 2.18336 7 2.1875ZM3.33594 3.88281L10.0494 10.7319C9.1889 11.4347 8.11099 11.8166 7 11.8125C4.33694 11.8125 2.1875 9.66306 2.1875 7C2.1875 5.80737 2.62063 4.72237 3.33594 3.88281Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsconding);
export default __webpack_public_path__ + "static/media/absconding.303ba1100532e1e8c1f869ffdcd6bd27.svg";
export { ForwardRef as ReactComponent };